import type { UseFormReturnType } from '@mantine/form';
import type { TestSuiteFetchResult } from '~/server/api/routers/test-suite-router';
import type { WorkerMode } from './SuiteSettings';
import { AUTO_CONCURRENCY } from '~/server/logic/common/workers';
import { stringifyVariableValue } from '~/common/variable/value';

// As a way of making it possible for us to reuse the form across the test suite settings and manual trigger modals
// We need a common type that can be used in both places. As we don't require any specific field from the form directly
// we can use the `any` type to avoid having to define a type for each of the modals (settings and manual trigger).

/* oxlint-disable @typescript-eslint/no-explicit-any */
export type SuiteForm = UseFormReturnType<any>;

export const getCommonSettingsFromSuite = (testSuite: TestSuiteFetchResult) => {
  const workerMode: WorkerMode = testSuite.numberOfWorkers === AUTO_CONCURRENCY ? 'auto' : 'manual';

  return {
    maxRetries: testSuite.maxRetries,
    operationDelayMs: testSuite.operationDelayMs,
    testTimeoutSeconds: Math.floor(testSuite.testTimeoutMs / 1000),
    numberOfWorkers: workerMode === 'auto' ? 1 : testSuite.numberOfWorkers,
    workerMode,
    notificationProfile: testSuite.notificationProfile,
    environment: testSuite.environment,
    variableOverrides: Object.entries(testSuite.variableOverrides ?? {}).map(([name, value]) => ({
      name,
      value: stringifyVariableValue(value.value),
      sensitive: value.sensitive,
      isEditing: false,
    })),
  } as const;
};
